import { useNavigate } from "react-router-dom";
import { Trash } from "@phosphor-icons/react";
import { StatusBadge, AgingBadge } from "../badges";

export const OrdersCardList = ({ orders, loading, emptyMessage, isAdmin, selected, toggleSelect, deleteOrder }) => {
  const navigate = useNavigate();
  return (
    <div className="space-y-3 md:hidden" data-testid="orders-card-list">
      {loading ? (
        <p className="p-6 text-center text-sm text-slate-400">Loading…</p>
      ) : orders.length === 0 ? (
        <p className="p-6 text-center text-sm text-slate-400" data-testid="orders-empty-state-mobile">{emptyMessage}</p>
      ) : (
        orders.map((o) => (
          <div key={o.id} data-testid={`order-card-${o.order_number}`} onClick={() => navigate(`/orders/${o.id}`)}
            className="cursor-pointer rounded-md border border-slate-200 bg-white p-4 transition-colors duration-150 active:bg-slate-50">
            <div className="flex items-start justify-between gap-2">
              <div className="flex min-w-0 items-start gap-3">
                {isAdmin && (
                  <input type="checkbox" data-testid={`select-order-card-${o.order_number}`}
                    checked={selected.includes(o.id)} onChange={() => {}} onClick={(e) => toggleSelect(e, o.id)}
                    className="mt-1 h-4 w-4 shrink-0 accent-slate-900" />
                )}
                <div className="min-w-0">
                  <p className="font-mono text-sm font-semibold text-slate-900">{o.order_number}</p>
                  <p className="mt-0.5 truncate text-sm font-medium text-slate-700">{o.customer_name}</p>
                  <p className="truncate text-xs text-slate-500">{o.location}</p>
                </div>
              </div>
              {isAdmin && (
                <button data-testid={`delete-order-card-button-${o.order_number}`} onClick={(e) => deleteOrder(e, o)}
                  className="shrink-0 p-1 text-slate-400 transition-colors duration-150 hover:text-red-600">
                  <Trash size={16} weight="duotone" />
                </button>
              )}
            </div>
            <div className="mt-3 flex flex-wrap items-center gap-2">
              <StatusBadge status={o.status} label={o.status_label} />
              <AgingBadge color={o.aging_color} days={o.age_days} />
            </div>
            <div className="mt-2 flex items-center justify-between text-xs text-slate-500">
              <span>{o.items.length} item{o.items.length > 1 ? "s" : ""} · Qty <span className="font-mono font-semibold text-slate-700">{o.total_quantity}</span></span>
              <span>{o.created_at.slice(0, 10)}</span>
            </div>
          </div>
        ))
      )}
    </div>
  );
};
